import React, { useState } from 'react';
import styled from 'styled-components';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import SentimentTopicSection from '../../ActiveTopic/Sentiments/SentimentTopicSection';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import { emoji_anger, emoji_disgust, emoji_fear, emoji_joy, emoji_neutral, emoji_sadness, emoji_surprise } from '../../../Common/SvgIcon/CommonSvgIcons';
import WordCloudAnalysis from '../../../components/InsightsWordCloud/WordCloudAnalysis';


const Footer = styled.div`
  color: #2a2929;
  font-family: Open Sans;
  font-size: 11px;
  font-weight: 400;
  text-align: right;
  margin-top: 30px;
  font-family: 'Inter';
`;
const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;

  & .title {
    /* color: #636363; */
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
  }
`;

const SentimentDrilldownWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 10px;
  padding-top: 0px;
  align-items: center;
  margin-bottom:30px;
`;

const EmotionAnalysisWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 0px 10px;
  align-items: center;
  margin-top: 30px;

  .titleContainer {
    margin: 25px 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .correlationGraphContainer {
    padding: 1px 20px 20px 20px;
  }

  & > p:first-child {
    ${'' /* color: #636363; */}
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;

    margin: 20px 0px 0px 10px;
  }
`;
const SentimentsTab = ({

    sentiments_tab = {},
    startDate = '',
    endDate = '',
    filterOption,
    filteredData,
    filteredStartDate,
    filteredEndDate,
    view,
    resetFlag,
    channel,
    hideDropdown,
    is_news = false,
    formatValue = 'dd-yyyy-MM',
    handleTabClick,
    job_id,
    insights_data={}
}) => {
    const [topTopicCount, setTopTopicCount] = useState({
        positive: '1 Topic',
        negative: '1 Topic',
        neutral: '1 Topic',
    });
    const [openDropdown, setOpenDropdown] = useState(null); // Manage open state for multiple dropdowns

    const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];
    const percentageValue = sentiments_tab?.sentiment_drilldown;

    const sentimentsData = [
        {
            name: 'Positive',
            value: parseFloat(percentageValue?.positive_sentiment),
            // fill: 'rgba(3, 198, 82, 0.8)',
            fill: '#36D174',
        },
        {
            name: 'Negative',
            value: parseFloat(percentageValue?.negative_sentiment),
            // fill: 'rgba(238, 19, 7,  0.8)',
            fill: '#F14239',
        },
        {
            name: 'Neutral',
            value: parseFloat(percentageValue?.neutral_sentiment),
            // fill: 'rgba(255, 225, 69, 0.8)',
            fill: '#FCDE94',
        },
    ];

    const sentimentsRenderScreen = {
        'Bar Graph':
            view === 'vertical' ? (
                <VerticalBarGraph
                    data={sentimentsData}
                    type={'%'}
                    job_id={job_id}
                    handleTabClick={(data) => handleTabClick(data)}
                    drillThroughType={'sentiment'}
                    width='105px'
                />
            ) : (
                <BarGraph
                    job_id={job_id}
                    handleTabClick={(data) => handleTabClick(data)}
                    drillThroughType={'sentiment'}
                    data={sentimentsData}
                    maxWidth={'60%'}
                    type={'%'}
                />
            ),
        'Pie Chart': (
            <RatingDonutChart
                job_id={job_id}
                handleTabClick={(data) => handleTabClick(data)}
                drillThroughType={'sentiment'}
                data={sentimentsData}
                width={500}
                type='percentage'
            />
        ),
        'Donut Chart': (
            <DonutChart
                job_id={job_id}
                handleTabClick={(data) => handleTabClick(data)}
                drillThroughType={'sentiment'}
                data={sentimentsData}
                sentiment={true}
                type='percentage'
            />
        ),
        'Funnel Chart': (
            <FunnelGraph
                job_id={job_id}
                handleTabClick={(data) => handleTabClick(data)}
                drillThroughType={'sentiment'}
                data={sentimentsData}
                maxWidth={'50%'}
                type={'%'}
            />
        ),
    };
    const handleTopTopicCountChange = (topic, topicType) => {
        if (topicType === 'positive') {
            setTopTopicCount({ ...topTopicCount, positive: topic });
        } else if (topicType === 'neutral') {
            setTopTopicCount({ ...topTopicCount, neutral: topic });
        } else if (topicType === 'negative') {
            setTopTopicCount({ ...topTopicCount, negative: topic });
        }
    };
    const renderTopics = (topicStrings, type) => {
        const topicData = Object.keys(topicStrings);
        // if (topicData.length === 0) return null;
        if (!topicStrings || Object.keys(topicStrings).length === 0) return null;

        const topicCount = parseInt(topTopicCount[type]);
        const topicKeys = topicData.slice(0, topicCount);

        // const topicKeys = topicData.filter(
        //   (key, index) => index < topTopicCount[type].split(' ')[1]
        // );
        return topicKeys.map((key, index) => (
            <div key={key}>{`Topic #${index + 1}  ${topicStrings[key]}`}</div>
        ));
    };
    const totalTopicsColumn = (topicStrings) => {
        const topicData = Object.keys(topicStrings);
        if (topicData.length === 0) return ['No Topic'];

        // const columns = [];
        // topicData.forEach((_, index) => {
        //   columns.push('Topic ' + (index + 1));
        // });
        const columns = topicData.map(
            (_, index) => `${index + 1} Topic${index + 1 > 1 ? 's' : ''}`
        );

        return columns;
    };



    const startDateParsed = useParsedStartDate(
        resetFlag,
        filteredStartDate,
        startDate,
        formatValue
    );
    const endDateParsed = useParsedEndDate(
        resetFlag,
        filteredEndDate,
        endDate,
        formatValue
    );


    if (Object.keys(sentiments_tab).length === 0) {
        return (
            <h2
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: '30px',
                }}
            >
                Insufficient Data
            </h2>
        );
    }


  const emotionAnalysis = [
    {
      name: 'Neutral',
      value:insights_data?.emotion_analysis[0].neutral,
      fill: '#FDE3A2',
       },
    {
      name: 'Surprise',
      value:insights_data?.emotion_analysis[0].surprise,
      fill: '#4FD786',
      },
    {
      name: 'Joy',
      value: insights_data?.emotion_analysis[0].joy,
      fill: '#E651CE',
      },
    {
      name: 'Fear',
      value:insights_data?.emotion_analysis[0].fear,
      fill: '#FFB84D',
       },
    {
      name: 'Sadness',
      value:insights_data?.emotion_analysis[0].sadness,
      fill: '#5C9BDB',
       },
    {
      name: 'Anger',
      value: insights_data?.emotion_analysis[0].anger,
      fill: '#F14239',
      },
    {
      name: 'Disgust',
      value:insights_data?.emotion_analysis[0].disgust,

      fill: '#8862D3',
      },
  ];

    
  const renderScreen = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          data={emotionAnalysis}
          maxWidth={'70%'}
          type={'%'}
          title={'Emotional_Analysis'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'emotion'}
          summary={
            resetFlag === true && filteredData
              ? filteredData?.emotion_summary
              : insights_data?.emotion_summary
          }
        />
      ) : (
        <BarGraph
          data={emotionAnalysis}
          maxWidth={'70%'}
          type={'%'}
          barHeight={'32px'}
          barHeightHover={'40px'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'emotion'}
          emojiList={{
            neutral: emoji_neutral,
            surprise: emoji_surprise,
            joy: emoji_joy,
            fear: emoji_fear,
            sadness: emoji_sadness,
            anger: emoji_anger,
            disgust: emoji_disgust,
            length: 2,
          }}
          title={'Emotional_Analysis'}
          summary={insights_data?.emotion_summary
          }
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        data={emotionAnalysis}
        width={500}
        type='percentage'
        title={'Emotional_Analysis'}
        summary={insights_data?.emotion_summary
        }
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
      />
    ),
    'Donut Chart': (
      <DonutChart
        data={emotionAnalysis}
        type='percentage'
        title={'Emotional_Analysis'}
        summary={insights_data?.emotion_summary
        }
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        data={emotionAnalysis}
        maxWidth={'80%'}
        type={'%'}
        title={'Emotional_Analysis'}
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'emotion'}
        summary={insights_data?.emotion_summary
        }
      />
    ),
  };
    return (
        <Wrapper>

            <SentimentDrilldownWrapper>
                <GraphHOC
                    title={'Sentiment Drilldown'}
                    options={options}
                    renderScreen={sentimentsRenderScreen}
                    graphWidth={'100%'}
                    margin={'20px 0px 20px 50px'}
                    option={filterOption}
                    hideDropdown={hideDropdown}
                    startDate={startDateParsed}
                    endDate={endDateParsed}
                    formatValue={formatValue}
                    showDate={false}
                    infoText={
                        channel == 'youtube' ?
                            `Analyze viewer comments on YouTube videos and Shorts by sentiment, and view key topics within each. 

                Minimum of 5 comments needed to display a sentiment category.`
                            :
                            channel == 'enterprise' ?
                                `Analyze sentiment distribution across your records. Each sentiment category is shown when at least 5 relevant records are available.`
                                :
                                `Analyzes user ${channel === 'instagram' || channel == 'facebook'
                                    ? 'comments'
                                    : 'posts'
                                } by sentiment—positive, negative, or neutral—and highlights key topics associated with each category, requiring a minimum of 5 data points per sentiment for inclusion.`}
                />
                <SentimentTopicSection
                    label='Positive Sentiments the posts were majorly related to:'
                    className='positiveTopic'
                    dropdownId='dropdown1'
                    topicData={sentiments_tab?.topic_analysis?.positive_topics}
                    sentimentKey='positive'
                    handleChange={handleTopTopicCountChange}
                    renderTopics={renderTopics}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    totalTopicsColumn={totalTopicsColumn}
                />

                <SentimentTopicSection
                    label='Neutral Sentiments the posts were majorly related to:'
                    className='neutralTopic'
                    dropdownId='dropdown2'
                    topicData={sentiments_tab?.topic_analysis?.neutral_topics}
                    sentimentKey='neutral'
                    handleChange={handleTopTopicCountChange}
                    renderTopics={renderTopics}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    totalTopicsColumn={totalTopicsColumn}
                />

                <SentimentTopicSection
                    label='Negative Sentiments the posts were majorly related to:'
                    className='negativeTopic'
                    dropdownId='dropdown3'
                    topicData={sentiments_tab?.topic_analysis?.negative_topics}
                    sentimentKey='negative'
                    handleChange={handleTopTopicCountChange}
                    renderTopics={renderTopics}
                    openDropdown={openDropdown}
                    setOpenDropdown={setOpenDropdown}
                    totalTopicsColumn={totalTopicsColumn}
                />
                <Footer>
                    {` This data is observed from ${startDateParsed} to ${endDateParsed}`}
                </Footer>
            </SentimentDrilldownWrapper>


            <WordCloudAnalysis
                infoText={'Visualizes the most frequent keywords in your uploaded data. Use filters to refine the view.'}
                showSwitchTab={false}
                insightsData={ insights_data }
                hideDropdown={hideDropdown}
                startDate={startDateParsed}
                endDate={endDateParsed}
                formatValue={formatValue}
                channel={channel}
                showKeyWordDropDown={false}
            />

            
            <EmotionAnalysisWrapper>
                <GraphHOC
                    formatValue={formatValue}
                    title={'Emotion Analysis'}
                    options={options}
                    renderScreen={renderScreen}
                    graphWidth={'100%'}
                    margin={'20px 0px 20px 50px'}
                    startDate={startDateParsed}
                    endDate={endDateParsed}
                    option={filterOption}
                    hideDropdown={hideDropdown}
                    infoText={'Analyze your uploaded data to reveal the distribution of seven core emotions across records.'}
                />
            </EmotionAnalysisWrapper>


        </Wrapper>
    );
};


export default SentimentsTab;